import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { DateService } from '../../shared/services/date.service';
import { AuthService } from '../../shared/services/auth.service';
import { ColDef } from 'ag-grid-community';
import { DateFilterNewComponent } from '../../shared/components/date-filter-new/date-filter-new.component';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  standalone: false,
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {

  gridApi: any;
  apiUrl: any;
  selectedTransactionType: string = 'Both';
  transactionType: string = 'all';
  selectedFromDate: any = null;
  selectedToDate: any = null;
  constructor(private _api: ApiService,
    private _dateService: DateService,
    private _auth: AuthService
  ) {

  }

  columnDefs: ColDef[] = [
    {
      field: 'createdAtdatePickerRange',
      sortable: false,
      headerName: 'Entry Date',
      filter: false, // Reference the class directly
      valueGetter: (params) => params.data?.createdAt,
      valueFormatter: (params) =>
        this._dateService.getDDMMYYYYfromEPOC(params.value),
    },
    {
      headerName: 'Type',
      field: 'isRemittance',
      editable: false,
      filter: false,
      width: 250,
      valueFormatter: (params: any) => {
        if (!params.data) {
          return 'Unknown';
        }

        const isRemittance = params.data.isRemittance;
        const isBill = params.data.isBill;

        if (!isRemittance) {
          return 'Payment';
        } else if (isRemittance && isBill) {
          return 'Bill Payment';
        } else if (isRemittance && !isBill) {
          return 'Remittance';
        }

        return 'Unknown';
      },
      cellClass: (params: any) => {
        if (!params.data) {
          return 'text-muted'; // Unknown (gray)
        }

        const isRemittance = params.data.isRemittance;
        const isBill = params.data.isBill;

        if (!isRemittance) {
          return 'text-success'; // Payment (green)
        } else if (isRemittance && isBill) {
          return 'text-warning'; // Bill Payment (yellow)
        } else if (isRemittance && !isBill) {
          return 'text-primary'; // Remittance (blue)
        }

        return 'text-muted'; // Unknown (gray)
      }
    },
    {
      headerName: 'Transaction Id',
      field: 'createdAt',
      editable: false,
      sortable: true,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      },
      valueGetter: (params) => {
          return params?.data?.originationCountry?.country_code + params?.data?.recipientCountry?.country_code  +  params?.data?.createdAt;
        },
      
    },
    {
      headerName: 'Amount',
      field: 'conversions',
      editable: false,
      filter: false,
      sortable: false,
      valueGetter: (params) => {
        if (params?.data) {
          const datum = JSON.parse(params?.data?.conversions);
          const isIssuer = this._auth.getUser()?.partnerId?.type === 'Issuer';
          if (isIssuer) {
            return (datum?.customerPays?.currency || '') + ' ' + (datum?.customerPays?.amount || '') + ' (' + (datum?.recipientGets?.currency || '') + ' ' + (datum?.recipientGets?.amount || '') + ')';
          }
          return (datum?.recipientGets?.currency || '') + ' ' + (datum?.recipientGets?.amount || '') + ' (' + (datum?.customerPays?.currency || datum?.sourceCurrency || '') + ' ' + (datum?.customerPays?.amount || datum?.sourceAmount || '') + ')';
        } else {
          return "";
        }
      },
    },
    {
      headerName: 'Merchant Name',
      field: 'merchantName',
      editable: false,
      sortable: true,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    {
      headerName: 'Customer Name',
      field: 'customerId.name',
      editable: false,
      sortable: true,
      filter: true,
      width: 250,
      filterParams: {
        filterOptions: ['contains'],
        maxNumConditions: 1
      }
    },
    // {
    //   headerName: 'Customer EmailId',
    //   field: 'customerId.emailId',
    //   editable: false,
    //   filter: true,
    // },
    //  {
    //   headerName: 'Source Partner',
    //   field: 'sourceBankId.name',
    //   editable: false,
    //   filter: true,
    // },
    {
      headerName: 'Source Country',
      field: 'originationCountry.displayName',
      editable: false,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Destination Country',
      field: 'recipientCountry.displayName',
      editable: false,
      sortable: true,
      filter: true,
    },
    
    // {
    //   headerName: 'Location',
    //   field: 'location',
    //   editable: false,
    //   filter: false,
    //   valueFormatter: (params) => this.getLatLongFromLocation(params.value),
    // },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      sortable: true,
      filter: true,
    },
    // {
    //   headerName: 'Date',
    //   field: 'createdAt',
    //   editable: false,
    //   filter: false,
    //   valueFormatter: (params) =>
    //     this._dateService.getFormattedDateWithAMPM(params.value),
    // },
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  ngOnInit(): void {
    const vm = this;
    const user = vm._auth.getUser();
    vm.selectedTransactionType = user.partnerId.type;
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      // vm.gridApi.sizeColumnsToFit();
    }
  }

  getLatLongFromLocation(value: string): string {
    if (!value) return '-';
    try {
      const loc = (JSON.parse(value));

      if (loc.coords) {
        const latitude = loc.coords.latitude;
        const longitude = loc.coords.longitude;
        return latitude + ', ' + longitude;
      }
      return '-';
    } catch (e) {
      return '-';
    }
  }

  getTransactionAmount(value: string): string {
    if (!value) return '-';
    try {
      const conversions = JSON.parse(value);
      return conversions.transactionAmount ? conversions.transactionAmount.toString() : '-';
    } catch (e) {
      return '-';
    }
  }


  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        const user = vm._auth.getUser();
        this.apiUrl = '/partners/auth/transactions/' + vm.selectedTransactionType + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        // Object.keys(filterData).forEach(function (k) {
        //   if (k && filterData[k]) {
        //     var filterValue = filterData[k].filter;
        //     if (k === 'amount') {
        //       vm.apiUrl += "&" + k + "_FULLMATCH=" + filterValue;
        //     } else {
        //       vm.apiUrl += "&" + k + "_like=" + filterValue;
        //     }
        //   }
        // });
        Object.keys(filterData).forEach((k) => {
          if (k && filterData[k]) {

            const filterValue = filterData[k].filter;

            // Date range filter
            if (k === 'createdAtdatePickerRange') {
              vm.apiUrl += `&${k}=${filterValue}`;
            }

            // Amount exact match
            else if (k === 'amount') {
              vm.apiUrl += `&${k}_FULLMATCH=${filterValue}`;
            }

            // Text filters
            else {
              // createdAt has a 4-letter country-code prefix, strip it for backend lookup
              const val = k === 'createdAt' ? filterValue.substring(4) : filterValue;
              vm.apiUrl += `&${k}_like=${val}`;
            }
          }
        });
        // Add transaction type filter
        if (this.transactionType === 'payment') {
          this.apiUrl += '&isRemittance=false';
        } else if (this.transactionType === 'bill-payment') {
          this.apiUrl += '&isRemittance=true&isBill=true';
        } else if (this.transactionType === 'remittance') {
          this.apiUrl += '&isRemittance=true&isBill=false';
        }

        // Add date filter
        if (vm.selectedFromDate && vm.selectedToDate) {
          const fromTimestamp = vm._dateService.dateToTimestamp(vm.selectedFromDate);
          const toTimestamp = vm._dateService.dateToTimestamp(vm.selectedToDate);
          if (!isNaN(fromTimestamp) && !isNaN(toTimestamp) && fromTimestamp > 0 && toTimestamp > 0) {
            vm.apiUrl += '&createdAtdatePickerRange=' + fromTimestamp + ',' + toTimestamp;
          }
        }

        if (params.sortModel && params.sortModel.length > 0) {
          const sortFields = params.sortModel.map(s => s.colId).join(',');
          const sortOrders = params.sortModel.map(s => s.sort).join(',');
          vm.apiUrl = vm.apiUrl + '&_sort=' + encodeURIComponent(sortFields) + '&_order=' + encodeURIComponent(sortOrders);
        }

        vm._api.getData(this.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            const dt: any = [];
            Object.keys(res.data).map(r => {
              const obj = { type: r, value: res.data[r] };
              dt.push(obj);
            });
            res.data.value = dt;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onTransactionTypeChange() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }
  filterTransactions(type: string) {
    this.transactionType = type;
    if (this.gridApi) {
      this.gridApi.refreshInfiniteCache();
    }
  }

  onDateSelected(result: { fromDate: any, toDate: any }) {
    const vm = this;
    vm.selectedFromDate = result.fromDate;
    vm.selectedToDate = result.toDate;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

}
